import { graphql } from 'gatsby'
import get from 'lodash.get'
import React from 'react'
import { CardActu } from '../components/card-actu'
import styled from 'styled-components'
import HTMLBlock from '../components/html-content'
import Layout from '../components/layout'
import Responsive from '../components/responsive'
import Seo from '../components/seo'
import Title from '../components/titles'
import colors from '../theme/colors'
import Masonry from 'react-masonry-css'

const Actualites = ({ data, uri }) => {
    const { title, actualites_description } = get(data, 'prismicActualites.data')
    const { nodes } = get(data, 'allPrismicPost')

    const breakpointColumnsObj = {
        default: 4,
        1450: 3,
        870: 2,
        630: 1
    }

    return (
        <>
            <Seo title={title.text} />
            <Layout uri={uri} withMiniHeader>
                <StyledSection>
                    <Responsive>
                        <Title size='large' as='h2' withDot>
                            {title.text}
                        </Title>

                        <HTMLBlock>{actualites_description.html}</HTMLBlock>
                    </Responsive>

                    {nodes.length > 0 && (
                        <StyledPostContainer>
                            {/*Currently sorted by last_publication_date (most recent edit first)*/}
                            <StyledMasonry breakpointCols={breakpointColumnsObj}>
                                {nodes.map((post, index) => {
                                    return (<CardActu post={post} key={`card-${index}`} />)
                                })}
                            </StyledMasonry>
                        </StyledPostContainer>
                    )}
                </StyledSection>
            </Layout>
        </>
    )
}

const StyledSection = styled.section`
  position: relative;
  overflow: hidden;
  z-index: 10;
  min-height: 90vh;
  padding: 4rem 0;
`

const StyledPostContainer = styled.div`
  max-width: 1630px;
  margin: 2rem 0;
  border-radius: 10px;
  background-color: ${colors.beige};
  padding: 10px;
  @media (min-width: 1150px) {
    margin: 2rem auto;
  }
`

const StyledMasonry = styled(Masonry)`
  padding: 4px 0;
  display: flex;
  gap: 8px;
`

export const query = graphql`
    query ActuEneance {
        prismicActualites {
            uid
            data {
                title {
                    text
                }
                actualites_description {
                    html
                }
            }
        }
        allPrismicPost(sort: { fields: [last_publication_date], order: DESC }) {
            nodes {
                uid
                data {
                    title {
                      text
                    }
                    cover {
                      alt
                      localFile {
                        childImageSharp {
                          gatsbyImageData
                        }
                      }
                    }
                    content {
                      html
                    }
                }
            }
        }
    }
`

export default Actualites